import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PaymentIcon from '../../../assets/SvgIcons/PaymentIcon';
import Button from '@mui/material/Button';
import SecureIcon from '../../../assets/SvgIcons/SecureIcon';
import { Theme, useTheme } from '@mui/material/styles';
import { isLight } from '../../../common/helpers';
import { KnownBreakpoints, THEME_BREAKPOINTS } from '../../../common/constants';
import useMediaQuery from '@mui/material/useMediaQuery';
import { NamedRoute } from '../../../common/hooks/useNamedRoute';

const styles = {
    content: (theme: Theme) => ({
        zIndex: 100,
        position: 'sticky',
        bottom: 0,
        padding: '22px',
        borderRadius: '20px 20px 0 0',
        margin: '0 40px',
        boxShadow: '0px 3px 3px 0px #283D5B33',
        backgroundColor: isLight(theme)
            ? theme.palette.primary.dark
            : theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        color: theme.palette.common.white,
        alignItems: 'center',
        [theme.breakpoints.down(1000)]: {
            flexDirection: 'column',
            gap: '10px',
        },
        [theme.breakpoints.down(THEME_BREAKPOINTS[KnownBreakpoints.tablet])]: {
            padding: '18px 20px',
            margin: '0 20px',
            gap: '15px',
        },
    }),
    bottomTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    title: (theme: Theme) => ({
        ...theme.typography.h5,
        lineHeight: '24px',
    }),
    paymentIcon: {
        fontSize: '25px',
    },
    applyButton: (theme: Theme) => ({
        width: '350px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        lineHeight: '16.41px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
        [theme.breakpoints.down(THEME_BREAKPOINTS[KnownBreakpoints.tablet])]: {
            width: '100%',
        },
    }),
    secureContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    secureIcon: {
        fontSize: '22px',
    },
    secureText: (theme: Theme) => ({
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: '10px',
        lineHeight: '11.72px',
        [theme.breakpoints.down(THEME_BREAKPOINTS[KnownBreakpoints.tablet])]: {
            color: theme.palette.warning.light,
        },
    }),
};

const ApplyLaptopMobileBottom: FunctionComponent = () => {
    const theme = useTheme<Theme>();
    const isMobile = useMediaQuery(
        theme.breakpoints.down(THEME_BREAKPOINTS[KnownBreakpoints.tablet]),
    );

    return <Box sx={ styles.content as any }>
        { !isMobile && <Box sx={ styles.bottomTitleContainer }>
            <Typography
                component="h5"
                sx={ styles.title }
                textAlign="center"
            >
                Get your money today
            </Typography>
            <PaymentIcon
                fill={ theme.palette.common.white }
                sx={ styles.paymentIcon }
            />
        </Box> }
        <Button
            sx={ styles.applyButton }
            href={ NamedRoute.CREATE_APPLICATION }
        >
            Apply for a loan
        </Button>
        <Box sx={ styles.secureContainer }>
            <SecureIcon
                fill={ !isMobile
                    ? theme.palette.common.white
                    : theme.palette.warning.light
                }
                sx={ styles.secureIcon }
            />
            <Typography
                component="h6"
                sx={ styles.secureText }
                textAlign="center"
            >
                Applying does
                <span style={{ fontWeight: 700 }}>{ ' NOT ' }</span>
                affect your FICO® Score!
            </Typography>
        </Box>
    </Box>;
};

export default ApplyLaptopMobileBottom;
